/**
 * Each tab is its own route, `/fleet/<tab>`, and each record lives under its tab, `/fleet/<tab>/<id>`, so the URL, the
 * breadcrumbs and the sidebar's Fleet highlight all agree. The office thinks of a truck and the trailer it pulls as one unit
 * (gitaumoses4/chukua#390), so trucks and trailers share the Units tab; a unit's address is its registration (`units.paths.ts`).
 */
export const FLEET_TABS = ['units', 'owners'] as const;
export type FleetTab = (typeof FLEET_TABS)[number];

export const FLEET_TAB_LABELS: Record<FleetTab, string> = { units: 'Units', owners: 'Owners' };

export function fleetTabPath(tab: FleetTab): string {
  return `/fleet/${tab}`;
}

export function fleetRecordPath(tab: FleetTab, id: string): string {
  return `/fleet/${tab}/${id}`;
}
